import instance from '@/apis'
const otc = '/c2c'
// 我的广告
export const myAd = params => {
  return instance({
    method: 'get',
    url: otc + '/v3/merchant/ad/my',
    params
  })
}

// 发布广告
export const createAd = data => {
  return instance({
    method: 'post',
    url: otc + '/v3/merchant/ad/create',
    data
  })
}

// 修改广告
export const updateAd = data => {
  return instance({
    method: 'put',
    url: otc + '/v3/merchant/ad/modify',
    data
  })
}

// 广告详情
export const queryAdDetails = id => {
  return instance({
    method: 'get',
    url: otc + `/v3/public/merchant/ad/detail/${id}`,
  })
}

// 获取法币 支付时效下拉 公共
export const fetchExpireTime = params => {
  return instance({
    method: 'get',
    url: otc + '/v3/public/option/box',
    params
  })
}

// 发布广告（新建）里面的付款方式列表
export const fetchPaymentList = data => {
  return instance({
    method: 'get',
    url: otc + '/v3/user-payment/optional',
    data
  })
}

// 上下架广告
export const changeAdStatus = ({id, type}) => {
  return instance({
    method:'post',
    url: otc + `/v3/merchant/ad/status-change/${id}?type=${type}`,
  })
}

//删除广告
export const deleteAd = (delId) => {
  return instance({
    method:'delete',
    url:otc + `/v3/merchant/ad/remove/${delId}`
  })
}

// 发布广告配置获取
export const publishAd = params => {
  return instance({
    method: 'get',
    url: otc + '/v3/public/config/publish-ad',
    params
  })
}

// 用户资产查询-单个币种
export const queryUserAssets = currency => {
  return instance({
    method: 'get',
    url: otc + `/v3/assets/${currency}`,
  })
}

// 获取数字货币与法币兑换率
export const exchange = params => {
  return instance({
    method: 'get',
    url: otc + `/v3/public/option/exchange`,
    params
  })
}